import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=12d2cda0&scoped=true&lang=html&"
import script from "./Partners.vue?vue&type=script&lang=js&"
export * from "./Partners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2cda0",
  null
  
)

export default component.exports